<template>
	<UiLoader class="spacing" />
</template>

<script setup>
	import Keycloak from 'keycloak-js';
	const endpoints = useEndpoints();
	const apiToken = useToken();
	const { getAppUrl } = useApiRoutes();
	const url = useUrl();
	const {objectToFormData} = useKeycloak();

	onMounted(async () => {
		await useApi(`${endpoints.get('_post_hapi_auth_api_config')}`, {
			method: 'POST',
			body: {success_url: getAppUrl('auth')},
		}).then(async (res) => {
			//console.log('res', res);

			if(res.success) {
				const url = new URL(res.data.old_redirect_login_url);
				const redirectOldUrl = url.searchParams.get("redirect");

				var keycloak = new Keycloak({
					url: res.data.config.url,
					realm: res.data.config.username,
					clientId: res.data.config.client_id
				});

				keycloak.init({
					onLoad: 'check-sso',
					silentCheckSsoRedirectUri: window.location.origin + '/sso/silent-check-sso.html'
				}).then(function(authenticated) {
					console.debug('keycloak.authenticated', authenticated);

					if (authenticated) {
						// redirect to auth
						keycloak.loadUserProfile().then(async function(profile) {
							console.debug('keycloak authenticated, tokenParsed', keycloak.tokenParsed, 'idToken', keycloak.idToken);

							const formData = new URLSearchParams();
							formData.append('jwtToken', keycloak.idToken);
							objectToFormData(keycloak.tokenParsed, formData);

							const response = await fetch(`/api/auth/login/?redirect=${redirectOldUrl}`, {
								method: 'POST',
								headers: {
									'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
								},
								body: formData.toString(),
							});

							const data = await response.json();
							console.debug('response_data', data);

							if (data.response === 'ok' && data.redirect_url) {
								setTimeout(async () => {
									await apiToken.generate();
									await useApi(`${endpoints.get('_post_hapi_auth_login_api')}`, {
										method: 'POST',
										body: {success_url: getAppUrl('auth')},
									}).then(res=> {
										console.debug(res);
									});
									document.location = data.redirect_url;
								}, 300);
							} else if (data.response === 'error' && data.redirect_url) {
								keycloak.logout({
									locale: 'sl',
									redirectUri: `${data.redirect_url}&logout=1`,
								});
								setTimeout(async () => {
									await apiToken.generate();
									const config = useAppConfig();
									await useApi(`/${config.api}/${config.apiVersion}/misc/headers-check/`);
									document.location = data.redirect_url;
								}, 300);
							}
						})
					} else {
						window.location = keycloak.createLoginUrl({locale: 'sl'});
					}
				});
			} else {
				await navigateTo({path: '/'});
			}
		});
	});
</script>
